import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { WallAnalysisRequest, WallAnalysisResponse } from './types';

export function useWallAnalysisQuery(req: WallAnalysisRequest) {
  const [debounced, setDebounced] = useState(req);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(req), 300);
    return () => window.clearTimeout(t);
  }, [req]);
  return useQuery<WallAnalysisResponse>({
    queryKey: ['analysis', 'walls', debounced],
    queryFn: async () => (await api.post('/api/analysis/walls', debounced)).data,
    placeholderData: (prev) => prev,
    retry: false,
    staleTime: 60_000,
  });
}
